export var AccountType;
(function (AccountType) {
    AccountType["Digital"] = "digital";
    AccountType["Fiat"] = "fiat";
    AccountType["Card"] = "card";
    AccountType["Benefit"] = "benefit";
    AccountType["Knet"] = "knet";
    AccountType["Mada"] = "mada";
})(AccountType || (AccountType = {}));
export var Jurisdiction;
(function (Jurisdiction) {
    Jurisdiction["Bahrain"] = "bhr";
    Jurisdiction["Turkey"] = "tur";
    Jurisdiction["UAE"] = "uae";
    Jurisdiction["BVI"] = "bvi";
})(Jurisdiction || (Jurisdiction = {}));
export var SupportSubdomain;
(function (SupportSubdomain) {
    SupportSubdomain["Default"] = "support-center";
    SupportSubdomain["BHR"] = "support-bh";
    SupportSubdomain["TUR"] = "support-tr";
    SupportSubdomain["UAE"] = "support-ae";
})(SupportSubdomain || (SupportSubdomain = {}));
export var CountryISOCodes;
(function (CountryISOCodes) {
    CountryISOCodes["Turkey"] = "TUR";
    CountryISOCodes["SaudiArabia"] = "SAU";
})(CountryISOCodes || (CountryISOCodes = {}));
export var SecondFactorAuthType;
(function (SecondFactorAuthType) {
    SecondFactorAuthType["App"] = "app";
    SecondFactorAuthType["Authy"] = "authy";
    SecondFactorAuthType["Phone"] = "phone";
})(SecondFactorAuthType || (SecondFactorAuthType = {}));
export var SpecialIdentifier;
(function (SpecialIdentifier) {
    SpecialIdentifier["Tag"] = "Tag";
    SpecialIdentifier["Memo"] = "Memo";
})(SpecialIdentifier || (SpecialIdentifier = {}));
export var SessionKeys;
(function (SessionKeys) {
    SessionKeys["NextRoute"] = "nextRoute";
})(SessionKeys || (SessionKeys = {}));
